import React from "react";
import FilterItem from "../../assets/components/FilterItem";

const PointShopFilter = ({ handleClick, selected }) => {
  return (
    <div className="w-100 mt-1 mb-4 d-flex">
      <FilterItem
        title={"همه"}
        handleClick={() => handleClick("")}
        selected={selected === ""}
      />
      {/* <FilterItem
        title={"خریداری شده"}
        handleClick={() => handleClick("active")}
        selected={selected === "active"}
      /> */}
    </div>
  );
};

export default PointShopFilter;
